import { i18n } from '@localization'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'

import {
  addBasicDetailsToAddCustomer,
  addEmploymentDetails,
  getCriteriaIndexes,
  getOtpToAddCustomer,
  getPrefilledData,
  verifyOtpToAddCustomer,
} from './functions'
import { GetCiterialIndexesRequest, GetPrefilledDataRequest } from './types'

function useGetOtpToAddCustomer() {
  const toast = useToast()

  return useMutation(getOtpToAddCustomer, {
    onSuccess: (data) => {
      if (data?.lockedTill && data?.reason === 'Too many attempts') {
        toast?.show({
          intent: 'error',
          heading: data?.reason,
          hideAfter: 3000,
          description: data?.lockedTill,
        })
      }
    },
    onError: (error) => {
      console.warn('error', error)
    },
  })
}

function useVerifyOtpToAddCustomer() {
  return useMutation(verifyOtpToAddCustomer)
}

function useAddBasicDetailsToAddCustomer() {
  return useMutation(addBasicDetailsToAddCustomer)
}

function useGetPrefilledData(suppliedData: GetPrefilledDataRequest) {
  return useQuery(
    ['getPrefilledData', suppliedData.customerId],
    () => getPrefilledData(suppliedData),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
    }
  )
}

function useGetCriteriaIndexes(suppliedData: GetCiterialIndexesRequest) {
  const locale = i18n.locale
  return useQuery(
    ['getCriteriaIndexes', locale, suppliedData],
    () => getCriteriaIndexes(suppliedData),
    { refetchOnWindowFocus: false }
  )
}

function useAddEmploymentDetails() {
  return useMutation(addEmploymentDetails)
}

export {
  useAddBasicDetailsToAddCustomer,
  useAddEmploymentDetails,
  useGetCriteriaIndexes,
  useGetOtpToAddCustomer,
  useGetPrefilledData,
  useVerifyOtpToAddCustomer,
}
